export default class NumberUtils {
    public formatMoney = (value: any, currency: string = "BDT") => {
        const options = {
            style: "currency",
            currency: currency,
            minimumFractionDigits: 2,
        };

        /* if (Number(value) % 100 === 0) {
            options.minimumFractionDigits = 0
        }*/

        const formatter = new Intl.NumberFormat("en-IN", options);
        return formatter.format(this.round(this.toNumber(value), 2));
    };

    public formatNumber = (value: any, trimTrailingZeroes: boolean = true, digitCount: number = 2) => {
        if (value === null || value === undefined || value === "") return 0;

        const options = {
            style: "decimal",
            minimumFractionDigits: digitCount,
        };

        if (trimTrailingZeroes) {
            options.minimumFractionDigits = 0;
        }

        /*if (Number(value) % 100 === 0) {
            options.minimumFractionDigits = 0
        }*/

        const formatter = new Intl.NumberFormat("en-IN", options);
        return formatter.format(this.round(this.toNumber(value), digitCount));
    };

    public formatNumberInteger = (value: any) => {
        const options = {
            style: "decimal",
            minimumFractionDigits: 0,
        };

        /*if (Number(value) % 100 === 0) {
            options.minimumFractionDigits = 0
        }*/

        const formatter = new Intl.NumberFormat("en-IN", options);
        return formatter.format(this.round(this.toNumber(value), 0));
    };

    public formatPercentage = (value: number): string => {
        const options = {
            style: "percent",
            minimumFractionDigits: 1,
        };

        const formatter = new Intl.NumberFormat("en-IN", options);
        return formatter.format(this.round(this.toNumber(value), 2));
    };

    public percentageFormatter = (value: number): string => {
        const numericValue = this.round(this.toNumber(value), 2);

        const formatter = new Intl.NumberFormat("en-IN", {
            style: "percent",
            minimumFractionDigits: 1,
        });

        return formatter.format(numericValue / 100);
    };

    public toNumber = (value: any): number => {
        if (value === null || value === undefined || value === "") return 0;
        else if (typeof value === "string") {
            value = value.replace(",", "");
        }
        return Number(value);
    };

    public round = (amount: number, digitCount: number): number => {
        let precision = Math.pow(10, digitCount);
        return Math.round(amount * precision) / precision;
    };

    public roundUp = (amount: number, digitCount: number): number => {
        let precision = Math.pow(10, digitCount);
        return Math.ceil(amount * precision) / precision;
    };

    public roundDown = (amount: number, digitCount: number): number => {
        let precision = Math.pow(10, digitCount);
        return Math.floor(amount * precision) / precision;
    };

    public roundTruncate = (amount: number, digitCount: number): number => {
        let precision = Math.pow(10, digitCount);
        return Math.trunc(amount * precision) / precision;
    };

    public toFixed = (number: any): string => {
        if (number === null || number === undefined || number === "") {
            return "";
        }
        return Number(number).toFixed(2);
    };

    public toBn = (number: any): string => {
        const toBn = (n) => n.replace(/\d/g, (d) => "০১২৩৪৫৬৭৮৯"[d]);

        return toBn(number.toString()); // Known issue: without 'string' the RegEx does not work.
    };

    public bnNumberToEn = (str: string = "") => {
        const map = {
            "০": "0",
            "১": "1",
            "২": "2",
            "৩": "3",
            "৪": "4",
            "৫": "5",
            "৬": "6",
            "৭": "7",
            "৮": "8",
            "৯": "9",
        }
        if (str === null || str === undefined || str === "")
            return "";

        return str.replace(/[০-৯]/g, (d) => map[d]);
    }
}
